import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { serverExtraHeaders } from "./common/utils/serverHeaders";

// Translations are served by the gateway from a single per-language document;
// each i18next namespace maps to a root section of that document
// (customer / bpsAdmin / utilityAdmin). The customer namespace is shared with
// the Flutter mobile app, so keys and single-brace {placeholders} must stay
// in sync with Zepp.WebApp/Gateway/Gateway.API/Translations/en.json.
const serverUrl = (process.env.REACT_APP_SERVER_URL || "").replace(/\/+$/, "");

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: "en",
    fallbackLng: "en",
    ns: ["customer"],
    defaultNS: "customer",
    backend: {
      // note: single-brace placeholders — the interpolation prefix/suffix
      // below applies to this template too
      loadPath: `${serverUrl}/api/translations/{lng}/{ns}`,
      customHeaders: serverExtraHeaders,
    },
    interpolation: {
      escapeValue: false,
      // match the mobile app's single-brace placeholder syntax
      prefix: "{",
      suffix: "}",
    },
    returnNull: false,
  });

export default i18n;
